import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const backendUrl = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, '');
const API = `${backendUrl}/api`;

// React 18 StrictMode mounts effects twice in dev; refs reset on remount, so a ref alone
// still runs two session exchanges and burns the one-time session_id (second -> 401).
const sessionExchangeInFlight = new Set();

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;
    const hashParams = new URLSearchParams(hash.replace('#', ''));
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = hashParams.get('session_id') || queryParams.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    if (sessionExchangeInFlight.has(sessionId)) {
      return;
    }
    sessionExchangeInFlight.add(sessionId);

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        sessionExchangeInFlight.delete(sessionId);
        setUser(res.data);
        navigate('/dashboard', { replace: true, state: { user: res.data } });
      } catch (error) {
        // Keep this log so auth failures can be diagnosed in browser devtools.
        console.error('Auth session exchange failed', {
          backendUrl,
          api: `${API}/auth/session`,
          message: error?.message,
          status: error?.response?.status,
          detail: error?.response?.data,
        });
        sessionExchangeInFlight.delete(sessionId);
        navigate('/login');
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto mb-4" />
        <p className="text-gray-600 font-ibm">Authenticating...</p>
      </div>
    </div>
  );
}
